import React, { forwardRef } from "react";
import { Col, Card, Spinner } from "react-bootstrap";
import { motion } from "framer-motion";

// Контракт:
//   старый (News/Publications/…): props.last.lastData (значение или массив)
//   новый (страницы статистики):  props.last.{loading|noData|value}
// Новые поля опциональны — старые вызовы работают как раньше.
const StaticCovidDataItem = forwardRef((props, ref) => {
  const L = props.last;

  let content;
  if (L.loading) {
    content = <Spinner size="sm" animation="border" variant="info" />;
  } else if (L.noData) {
    content = <h3 className="text-danger" style={{ fontSize: "1.15rem" }}>нет данных</h3>;
  } else if (L.value !== undefined) {
    content = <h3>{L.value}</h3>; // новый контракт (корректно показывает 0)
  } else {
    content = L.lastData ? (
      isNaN(L.lastData) ? <p className="text-danger">нет данных</p> : <h3>{L.lastData}</h3>
    ) : (
      <Spinner style={{ position: "absolute", top: "10%" }} size="sm" animation="border" variant="info" />
    );
  }

  return (
    <Col xs={12} md={4} ref={ref}>
      <Card border="light" style={({ width: "5rem" }, { height: "8rem" })} className="mx-2 my-2 shadow1">
        <Card.Body>
          <Card.Title className="text-center text-info">{content}</Card.Title>
          <Card.Text className="text-center">
            <small>{L.name}</small>
          </Card.Text>
        </Card.Body>
        <Card.Footer className="bg-white shadow1 mx-3 " style={{ width: "12rem" }}>
          <small className="text-muted">
            <small className="text-center">По данным на {L.lastDatadate ? L.lastDatadate : <div></div>}</small>
          </small>
        </Card.Footer>
      </Card>
    </Col>
  );
});

const MSCDItem = motion(StaticCovidDataItem);
export default MSCDItem;
export { StaticCovidDataItem };
